<script lang="ts">
  import { contentBlockComponents } from "$lib/portableText/utils";
  import type { SanityPicture } from "$lib/types/shared";
  import { PortableText } from "@portabletext/svelte";
  import Picture from "$lib/SanityPicture.svelte";
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import type { PageBanner } from "$lib/types/page";

  export let block: PageBanner;
</script>

<div class="box mx-edge-x p-4 my-8">
  <div class="grid tablet:grid-cols-[1fr_auto] items-center gap-4 tablet:px-4">
    <div class="laptop:text-lead">
      <PortableText
        value={block.content}
        components={contentBlockComponents}
        onMissingComponent={false}
      />
    </div>
    {#if block.image?.src}
      <div class="tablet:ml-4 laptop:ml-8 display-flex">
        <Picture
          pictureObject={(block.image as SanityPicture) || {}}
          sizes={`(min-width: ${br.wide}) 30vw, (min-width: ${br.desktop}) 40vw, (min-width: ${br.tablet}) 45vw, 90vw`}
          alt={block.image?.alt || ""}
          class="rounded-xl tablet:max-w-80 laptop:max-w-100 tablet:h-96 tablet:object-cover"
        />
      </div>
    {/if}
  </div>
</div>

<style lang="postcss">
  .box {
    --_box-bg: var(--primary-light);
    background-color: var(--_box-bg);
    border-radius: 1rem;
  }

  .box > :global(*) {
    margin-inline: 0;
  }

  @media (--tablet) {
    .box {
      padding-inline: var(--s-5);
    }
  }
</style>
